<template>
  <div class="agreements">
    <el-row>
      <el-card v-loading="loading" class="data">
        <div class="data-title flex-space-between" slot="header">
          <p> Agreements </p>
          <div>
            <el-tooltip content="Create Agreement" placement="top">
              <el-button type="success" circle icon="el-icon-plus" @click="openModal"></el-button>
            </el-tooltip>
          </div>
        </div>
        <div>
          <Table />
        </div>
      </el-card>
    </el-row>
    <Modal />
  </div>
</template>

<script>
import Table from "@/modules/admin/cms/components/agreement/Table.vue"
import Modal from "@/modules/admin/cms/components/agreement/Modal.vue"
import { mapMutations, mapState } from "vuex"

export default {
  name: "Agreement",

  components: { Table, Modal },

  computed: {
    ...mapState('agreement', ['loading'])
  },

  methods: {
    ...mapMutations('agreement', ['setModal', 'setModalAction', 'setAgreement']),

    openModal() {
      this.setAgreement({})
      this.setModalAction('create')
      this.setModal(true)
    }
  }
}
</script>

<style scoped lang="scss">

</style>